import { Component, Inject, OnInit, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Subject } from 'rxjs';
import { MatLegacySnackBar as MatSnackBar } from '@angular/material/legacy-snack-bar';
import { ProjectsService } from 'app/modules/projects/projects.service';
import { Project } from 'app/modules/projects/projects.types';
import {
  Account,
  ProjectType,
  PropertyType,
  ProjectStage,
  InvestmentType,
  Vehicle,
} from 'app/core/models/account.types';
import { AccountService } from 'app/core';
import { User } from 'app/core/models/user.types';

@Component({
  selector: 'project-sharing',
  templateUrl: './project-sharing.component.html',
  styleUrls: ['./project-sharing.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ProjectSharingComponent implements OnInit {
  filterForm: UntypedFormGroup;

  projectTypes: ProjectType[];
  propertyTypes: PropertyType[];
  projectStages: ProjectStage[];
  vehicles: Vehicle[];
  investmentTypes: InvestmentType[];
  users: User[];
  account: Account;
  shareLink: boolean = false;
  project: Project;
  publicShareUrl: string;
  authorizedPanels: any[] = [];
  public message: string = '';
  public permissionsDisplayed: boolean = false;

  savedFilter: any = null;
  public _emailAddresses: string[] = [];
  public panels: any[] = [];

  public isMapView: boolean = false;
  private _unsubscribeAll: Subject<void>;

  private shareUrl: ElementRef;
  @ViewChild('shareUrl') set content(content: ElementRef) {
    this.shareUrl = content;
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public matDialogRef: MatDialogRef<ProjectSharingComponent>,
    private _snackBar: MatSnackBar,
    private _projectsService: ProjectsService,
    private _accountService: AccountService,
  ) {
    this._unsubscribeAll = new Subject();

    this._accountService.currentAccount.subscribe((accountData) => {
      this.account = accountData;
    });
  }

  ngOnInit(): void {
    this.project = this.data.project;
    const definition = this.project.template?.definition;

    const panels = definition.dashboard.panels;
    for (const panelCol of panels) {
      for (const panelDef of panelCol) {
        this.panels.push(panelDef);
        if (panelDef.type == 'form' || panelDef.type == 'files' || panelDef.type == 'map') {
          this.authorizedPanels.push(panelDef?.id);
        }
      }
    }
  }

  togglePermissions() {
    this.permissionsDisplayed = !this.permissionsDisplayed;
  }

  togglePanelAll(): void {
    if (this.authorizedPanels.length > 0) {
      this.authorizedPanels = [];
    } else {
      this.authorizedPanels = [];
      for (const panel of this.panels) {
        this.authorizedPanels.push(panel?.id);
      }
    }
  }

  togglePanelPermissions(panel): void {
    if (this.authorizedPanels.includes(panel.id)) {
      this.authorizedPanels = this.authorizedPanels.filter((obj) => obj !== panel.id);
    } else {
      this.authorizedPanels.push(panel?.id);
    }
  }

  panelChecked(panelId): boolean {
    return this.authorizedPanels.includes(panelId);
  }

  generateShareableLink(): void {
    this._projectsService.shareProject(this.project.id, { panels: this.authorizedPanels }, true).subscribe((result) => {
      const resource = result[0];
      this.shareLink = true;
      this.publicShareUrl = resource.url;
      //this.publicShareUrl = `https://dashboard.termsheet.com/sharing/projects/${resource.token}`
      this.copyLinkToClipboard();
    });
  }

  copyLinkToClipboard(): void {
    setTimeout(() => {
      this.shareUrl.nativeElement.select();
      document.execCommand('copy');
      //this.shareUrl.nativeElement.setSelectionRange(0, 0);
      const snackBarRef = this._snackBar.open('Url copied to clipboard.', '', {
        duration: 3000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
    });
  }

  updateTags($event) {
    this._emailAddresses = $event;
  }

  /**
   * Discard the message
   */
  discard(): void {
    this.matDialogRef.close();
  }

  /**
   * Send the message
   */
  share(): void {
    this._projectsService
      .shareProject(this.project.id, { panels: this.authorizedPanels }, false, this._emailAddresses, this.message)
      .subscribe((result) => {
        const snackBarRef = this._snackBar.open('Deal has been sent.', '', {
          duration: 3000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
        this.discard();
      });
  }
}
